import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { globalFileIcon } from "../../../axiosInstance";
import { useDispatch, useSelector } from "react-redux";
import { setToggleCart } from "../../server/CartsOpen";
import { showAlertWithConfirm } from "../../server/ShowAlert";

const HeaderCart = ({ role, user, productsInCart }) => {
  const dispatch = useDispatch();
  const { orderSum, totalSum, deliveryPrice } = useSelector((state) => ({
    orderSum: state.productsInCart.orderSum,
    totalSum: state.productsInCart.totalSum,
    deliveryPrice: state.productsInCart.deliveryPrice,
  }));
  const [cartIsOpen, setCartIsOpen] = useState(true);
  const setCart = (setOpen) => {
    dispatch(setToggleCart(setOpen));
    setCartIsOpen(!cartIsOpen);
  };
  const goToCart = () => {
    dispatch(setToggleCart(false));
    setCartIsOpen(true);
    const availableItems = productsInCart.filter(
      (product) => product.quantity === 0,
    );
    if (availableItems.length > 0) {
      const itemNames = availableItems
        .map((item) => item.product?.name || "")
        .join("<br>");
      showAlertWithConfirm({
        msgHtml: `<div class="missing-items-alert">שים לב אלו הפריטים שאזלו מן המלאי: <div class="missing-items-container">
                    <strong>${itemNames}</strong></div></div>`,
      });
    }
  };
  return (
    <>
      {!role && user && productsInCart.length ? (
        <div className="cart-info-row">
          <div className="cart-in-header">
            <div className="sum-in-cart">
              <div className="sum-and-num-details">
                {productsInCart.length ? (
                  <p className="num-product-text">
                    {productsInCart.length} פריטים
                  </p>
                ) : null}
                {productsInCart.length ? (
                  <span className="btn-price">
                    <span>₪</span>
                    {(
                      parseFloat(orderSum) + parseFloat(deliveryPrice ?? 0)
                    ).toFixed(2)}
                  </span>
                ) : null}
              </div>
              {productsInCart.length && deliveryPrice != null ? (
                <NavLink
                  onClick={() => goToCart()}
                  className="to-pay-btn"
                  to="/cart"
                >
                  לתשלום
                </NavLink>
              ) : (
                <button className="to-pay-btn disabled" disabled>
                  לתשלום
                </button>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default HeaderCart;
